<template>
    <div>
        <table class="table table-bordered translator-table">
            <thead>
                <tr
                    style="margin-top: 0 !important; margin-bottom: 0 !important; padding-top: 0 !important; padding-bottom: 0 !important;">
                    <th class="th-ans-style table-primary fw-semibold th-panel-header" style="font-size: 14px;">
                        <i class="bi bi-pencil-square me-2" aria-hidden="true"
                            style="margin-top: 0 !important; margin-bottom: 0 !important; padding-top: 0 !important; padding-bottom: 0 !important; "></i>
                        Contenu à traduire
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td
                        style="margin-top: 0 !important; margin-bottom: 0 !important; padding-top: 0 !important; padding-bottom: 0 !important;">
                        <!-- Onglets Texte / Fichier Excel -->
                        <div class="o-tabs js-tabs">
                            <ul class="js-tablist" data-hx="h2" style="margin-top: 0px;padding: 0px;">
                                <li class="js-tablist__item">
                                    <a href="#tab-text" class="js-tablist__link" @click="switchMode('text')"
                                        style="font-size: 14px;">
                                        <i class="bi bi-pencil-square me-1" aria-hidden="true"></i> Texte
                                    </a>
                                </li>
                                <li class="js-tablist__item">
                                    <a href="#tab-file" class="js-tablist__link" @click="switchMode('file', $event)"
                                        style="font-size: 14px;">
                                        <i class="bi bi-file-earmark-excel me-1" aria-hidden="true"></i> Fichier Excel
                                    </a>
                                </li>
                            </ul>
                            <div class="js-tabcontent--container"
                                style="margin-top: 0 !important; margin-bottom: 0 !important; padding-top: 0 !important; padding-bottom: 0 !important;">
                                <!-- Panneau Texte -->
                                <div id="tab-text" class="js-tabcontent">
                                    <translator-text-input v-model="inputText" :is-loading="isLoading" />
                                </div>
                                <!-- Panneau Fichier Excel -->
                                <div id="tab-file" class="js-tabcontent">
                                    <translator-file-input ref="fileInput" :is-loading="isLoading"
                                        :is-disabled="!isUserLoggedIn" @file-selected="onFileSelected"
                                        @file-invalid="onFileInvalid" @clear="onFileInputCleared" />
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>

                <!-- Paramètres de traduction -->
                <tr>
                    <td class="bg-light"
                        style="margin-top: 0 !important; margin-bottom: 0 !important; padding-top: 0 !important; padding-bottom: 0 !important;">
                        <translator-parameter-input v-if="inputMode === 'text'" :is-loading="isLoading"
                            :selected-model.sync="selectedModel" :model-options="modelOptions"
                            :is-loading-models="isLoadingModels" />
                        <translator-file-parameter-input v-else :is-loading="isLoading" :is-disabled="!isUserLoggedIn"
                            :selected-model.sync="selectedModel" :model-options="modelOptions"
                            :is-loading-models="isLoadingModels" :output-columns.sync="outputColumns" />
                    </td>
                </tr>

                <!-- Bouton action -->
                <tr>
                    <td class="p-1">
                        <div class="d-flex justify-content-between align-items-center gap-4">
                            <button id="btn-effacer" type="button" class="btn btn--ghost btn--primary"
                                @click="clearActiveInput" :disabled="isLoading" aria-label="Effacer la saisie active">
                                <i class="bi bi-x-circle me-1" aria-hidden="true"></i>
                                Effacer
                            </button>
                            <!-- Mode texte : Traduire -->
                            <button v-if="inputMode === 'text'" id="btn-traduire" type="button"
                                class="btn btn--plain btn--primary" @click="translate"
                                :disabled="!inputText.trim() || inputText.length > config.input.maxLength || isLoading || !selectedModel"
                                aria-label="Lancer la traduction">
                                <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"
                                    aria-hidden="true"></span>
                                <i v-else class="bi bi-translate me-1" aria-hidden="true"></i>
                                {{ isLoading ? config.input.messages.translateButtonLoading :
                                    config.input.messages.translateButton }}
                            </button>
                            <!-- Mode fichier : Traduire et télécharger -->
                            <button v-else id="btn-traduire-fichier" type="button" class="btn btn--plain btn--primary"
                                @click="translateFile" :disabled="!selectedFile || isLoading || !selectedModel"
                                aria-label="Traduire et télécharger le fichier">
                                <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"
                                    aria-hidden="true"></span>
                                <i v-else class="bi bi-translate me-1" aria-hidden="true"></i>
                                {{ isLoading ? config.input.messages.translateFileButtonLoading :
                                    config.input.messages.translateFileButton }}
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import Vue from 'vue';
import TranslatorTextInput from './TranslatorTextInput.vue';
import TranslatorParameterInput from './TranslatorParameterInput.vue';
import TranslatorFileInput from './TranslatorFileInput.vue';
import TranslatorFileParameterInput from './TranslatorFileParameterInput.vue';
import config from '../config/translator.config.js';
import storeTranslator from '../store-translator.js';

/**
 * Composant principal du formulaire de traduction.
 * Orchestre la saisie du texte (TranslatorTextInput) et les paramètres
 * (TranslatorParameterInput), puis émet l'événement 'translate' avec
 * toutes les données nécessaires à l'appel API.
 *
 * @emits translate      - { text, model }
 * @emits translate-file - { file, modelId, direction }
 * @emits clear          - Lorsque la saisie est effacée
 */
export default {
    name: 'TranslatorInput',
    components: {
        TranslatorTextInput,
        TranslatorParameterInput,
        TranslatorFileInput,
        TranslatorFileParameterInput
    },
    props: {
        /** Indique si une traduction est en cours (désactive les interactions). */
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const isUserLoggedIn = Boolean(Vue.prototype.$ansPublicTranslatorAi?.isUserLoggedIn)
        return {
            /** Référence à la configuration globale du traducteur. */
            config,
            /** Indique si l'utilisateur est connecté (source : contexte WordPress localisé). */
            isUserLoggedIn,
            /** Mode de saisie actif : 'text' ou 'file'. Initialisé depuis le hash de l'URL. */
            inputMode: window.location.hash === '#tab-file' && isUserLoggedIn ? 'file' : 'text',
            /** Texte saisi par l'utilisateur, lié au composant TranslatorTextInput. */
            inputText: '',
            /** Fichier Excel sélectionné par l'utilisateur. */
            selectedFile: null,
            /** Colonnes de sortie pour la traduction par fichier. */
            outputColumns: getDefaultOutputColumns(),
            /** Fichier Excel brut sélectionné (objet File). */
            selectedRawFile: null,
            /** Garde-fou pour éviter la récursion de clear entre parent et enfant. */
            isInternalFileClear: false,
            /** Modèle de traduction sélectionné, lié à TranslatorParameterInput. */
            selectedModel: '',
            /** Liste des modèles disponibles pour le select (chargés depuis le middleware). */
            modelOptions: [],
            /** Vrai pendant le chargement initial des modèles, pour éviter l'affichage prématuré de l'erreur. */
            isLoadingModels: true,
        }
    },
    async created() {
        try {
            const models = await storeTranslator.recupererModelAI()
            this.modelOptions = models
            if (models.length > 0) {
                this.selectedModel = models[0].value
            }
        } finally {
            this.isLoadingModels = false
        }
    },
    methods: {
        /**
         * Émet l'événement 'translate' avec les paramètres bruts.
         * L'appel API est délégué au composant parent (AppTranslateAI)
         * afin que isLoading soit activé avant l'appel et que le loader
         * soit visible pendant toute la durée de la traduction.
         */
        translate() {
            if (!this.inputText.trim()) return
            this.$emit('translate', {
                text: this.inputText,
                model: this.selectedModel
            })
        },
        /** Réinitialise le texte saisi et émet l'événement 'clear'. */
        clearInput() {
            this.inputText = ''
            this.$emit('clear')
        },
        /** Efface la saisie active selon le mode courant. */
        clearActiveInput() {
            if (this.inputMode === 'text') {
                this.clearInput()
                return
            }

            this.clearFile()
        },
        /**
         * Émet l'événement 'translate-file' avec les paramètres fichier.
         * L'appel API est délégué au composant parent (AppTranslateAI)
         * afin que isLoading soit activé avant l'appel et que le loader
         * soit visible pendant toute la durée de la traduction fichier.
         */
        translateFile() {
            if (!this.selectedRawFile) return

            const [modelId, direction] = (this.selectedModel || '').split('|')

            this.$emit('translate-file', {
                file: this.selectedRawFile,
                modelId,
                direction,
                outputColumns: this.outputColumns
            })
        },
        /** Stocke le fichier sélectionné pour activer l'envoi vers le middleware. */
        onFileSelected({ file }) {
            this.selectedFile = file
            this.selectedRawFile = file
        },
        /** Réinitialise la sélection quand le fichier est invalide. */
        onFileInvalid() {
            this.selectedFile = null
            this.selectedRawFile = null
        },
        /** Réagit au clear émis par TranslatorFileInput. */
        onFileInputCleared() {
            if (this.isInternalFileClear) return

            this.selectedFile = null
            this.selectedRawFile = null
            this.resetFileParameters()
        },
        /** Réinitialise les paramètres spécifiques au mode fichier. */
        resetFileParameters() {
            this.selectedModel = this.modelOptions.length > 0 ? this.modelOptions[0].value : ''
            this.outputColumns = getDefaultOutputColumns()
        },
        /** Réinitialise le fichier sélectionné. */
        clearFile() {
            this.selectedFile = null
            this.selectedRawFile = null
            this.resetFileParameters()
            if (this.$refs.fileInput) {
                this.isInternalFileClear = true
                try {
                    this.$refs.fileInput.clearBatch()
                } finally {
                    this.isInternalFileClear = false
                }
            }
        },
        /** Empêche l'onglet fichier et ouvre la popin de connexion si l'utilisateur n'est pas connecté. */
        handleFileModeWhenLoggedOut(mode, event) {
            if (mode !== 'file' || this.isUserLoggedIn) return false

            this.blockTabEvent(event)
            this.openTranslatorFileLoginModal()
            this.inputMode = 'text'
            return true
        },
        /** Bloque le comportement natif et les handlers tiers sur le clic d'onglet. */
        blockTabEvent(event) {
            if (!event) return
            event.preventDefault()
            event.stopImmediatePropagation()
        },
        /** Ouvre la popin de connexion dédiée à la traduction par fichier. */
        openTranslatorFileLoginModal() {
            const modalElement = document.getElementById('popin-login-required-translator-file')
            if (!modalElement) return

            this.updateTranslatorFileLoginRedirect(modalElement)

            const jq = window.jQuery || window.$
            if (jq && jq.fn && jq.fn.modal) {
                jq(modalElement).modal('show')
                return
            }

            if (window.bootstrap && window.bootstrap.Modal) {
                new window.bootstrap.Modal(modalElement).show()
            }
        },
        /** Ajoute #tab-file dans redirect_to pour revenir sur l'onglet fichier après connexion. */
        updateTranslatorFileLoginRedirect(modalElement) {
            const loginLink = modalElement.querySelector('a.btn--plain')
            if (!loginLink) return

            const href = loginLink.getAttribute('href') || ''
            if (href.includes('%23tab-file') || href.includes('#tab-file')) return

            loginLink.setAttribute('href', href.replace(
                /(redirect_to=)([^&]*)/,
                (_, key, val) => key + encodeURIComponent(decodeURIComponent(val).split('#')[0] + '#tab-file')
            ))
        },
        /** Nettoie l'état quand on passe d'un mode de saisie à l'autre. */
        clearCurrentModeInput() {
            if (this.inputMode === 'text') {
                this.clearInput()
                return
            }
            this.clearFile()
        },
        /** Bascule entre les modes de saisie 'text' et 'file'. */
        switchMode(mode, event) {
            if (this.handleFileModeWhenLoggedOut(mode, event)) return
            if (mode === this.inputMode) return
            this.clearCurrentModeInput()
            this.inputMode = mode
            this.$emit('mode-changed', mode)
        }
    }
}

function getDefaultOutputColumns() {
    return Object.fromEntries(
        config.fileInput.outputColumns.map(col => [col.key, col.defaultValue])
    )
}
</script>

<style>
.table-responsive {
    margin-bottom: 0 !important;
}

.translator-table {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}
</style>